import loadSlick from '../helpers/loadSlick';

const $slider = $('.js-review-slider');
const $prev = $('.js-reviews-slider-prev');
const $next = $('.js-reviews-slider-next');

const reviewSlider = {
  initialize() {
    if ($slider.length) {
      loadSlick().then(() => {
        this.create();
      });
    }
  },

  create() {
    $prev.on('click', () => {
      $slider.slick('slickPrev');
    });

    $next.on('click', () => {
      $slider.slick('slickNext');
    });

    const options = $slider.data();

    const config = {};

    if (typeof options !== 'undefined') {
      const optionKeys = Object.keys(options);

      optionKeys.forEach((option) => {
        const regex = new RegExp('^slider', 'g');

        if (regex.test(option)) {
          let transformedOption = option.replace('slider', '');
          transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

          config[transformedOption] = options[option];
        }
      });
    }

    $slider.slick(config);
  },
};

export default reviewSlider;
